import React from "react";
import { ButtonBase, Typography } from "@material-ui/core";
import { IconNovedad, api } from "@portal/arq-portal-core"
import { makeStyles } from '@material-ui/core/styles';
import Image from 'material-ui-image';
import { abrirDetachedWindow } from "./helper";
const apiMeInteresa = "/MeInteresa/Imagen/?id=";
const useStyles = makeStyles(() => ({
    marcaContainer:{
        width: '100%',
        height: "180px",
        display: 'flex',
        justifyContent: 'flex-start', 
        alignItems: 'center', 
        backgroundColor: "white",
        position: "relative",
        '@media screen and (max-width: 767px)': {
            height: "180px",
        },
        '& > div':{
            width: "calc(100% - 300px)", 
            minWidth: '190px',
            paddingTop: '0 !important',
            height: 'inherit !important',
            '@media screen and (max-width: 767px)': {
                height: "180px",
            },
            '& > img': {
                height: 'inherit !important',
                objectFit: 'cover !important'
            }
        },
        '& .content': {
            width: '300px', 
            height: '180px',
            display: 'inline-block', 
            padding: '20px 20px !important', 
            alignSelf: 'flex-start', 
            textAlign: 'start',
            borderLeft: "1px solid #919191",
            '@media screen and (max-width: 767px)': {
                height: "180px",
            },
            '& .content-title': {
                fontSize: '16px',
                marginBottom: '.5rem',
                fontFamily: "Catalana-Bold",
                color: '#606060',
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                "-webkit-line-clamp": '2',
                "-webkit-box-orient": "vertical",
                minHeight: '36px',
                paddingTop: '10px',
                
            },
            '& .content-label': {
                display: 'block',
                marginBottom: '.5rem',
            },
            '& .content-description': {
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                color: '#606060',
                "-webkit-line-clamp": '4',
                "-webkit-box-orient": "vertical",
                '@media screen and (max-width: 767px)': {
                    "-webkit-line-clamp": 3,
                },
            },

        },
    },
    containerTitle:{
        display: 'flex',
        alignItems: 'baseline',
    },
    novedad:{
        position: 'relative',
        top: '5px',
        color: '#DC0028'
    },
    altavozMarca: {
        position: "absolute",
        left: "0px",
        top: "0px",
        width: "40px !important",
        height: "40px",
        zIndex: 1,
    }
}))



export default function Marca(props: { publicacion: any, defaultImage: any }) {
    const classes = useStyles(); 
    return(
        <ButtonBase className={classes.marcaContainer} onClick={()=>abrirDetachedWindow(props.publicacion.UrlBase)}>
            <img className={classes.altavozMarca} src='assets/altavoz.gif' alt='Imagen de carga'></img>
            <Image alt={props.publicacion.Titulo}
                src={api.getApiServer() + apiMeInteresa + props.publicacion.Imagen + "&tipo=N"}
                loading={props.defaultImage}
                errorIcon={props.defaultImage}
                cover={true}
            />
            <div className="content">
                <div className={classes.containerTitle}> 
                <Typography className="content-title" variant="h3" component="span" title={props.publicacion.Titulo}>{props.publicacion.Titulo}</Typography>    
                {props.publicacion.Novedad && <IconNovedad className={classes.novedad}/>} 
                </div>
                <Typography className="content-description" variant="caption" title={props.publicacion.DescripcionBreve}>{props.publicacion.DescripcionBreve}</Typography>
            </div>
        </ButtonBase>
    ) 
}